import { debounce } from 'lodash';
import { mapState } from 'vuex';

export default {
  props: {
    isNeedUpdate: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  computed: {
    ...mapState({
      loading: state => state.showLoading,
    }),
  },

  watch: {
    isNeedUpdate (value) {
      if (!value) {
        return;
      }

      this.resetNeedingUpdate();

      if (this.loading) {
        return;
      }

      debounce(this.reload, 10)();
    },
  },

  methods: {
    resetNeedingUpdate() {
      this.$emit('resetNeedingUpdate');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Charts/NeedUpdateMixin.js